import type { IconProps } from "../types";

export const FolderSync = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M9 20H2V3H8L10 6H22V8.5" />
    <path d="M12 10v4h4" />
    <path d="m12 14 1.535-1.605a5 5 0 0 1 8 1.5" />
    <path d="M22 22v-4h-4" />
    <path d="m22 18-1.535 1.605a5 5 0 0 1-8-1.5" />
  </svg>
);
